<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <!--<v-flex d-flex xs12>
          <v-layout row wrap align-center style="margin-top:0px;">
            <v-card style="margin-left:400px">
              <v-btn class="primary" v-on:click="sho1()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">In-Bound Delivery</v-btn>
              <v-btn class="primary" v-on:click="sho2()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Out-Bound Delivery</v-btn>
            </v-card>
          </v-layout>
        </v-flex>-->
        <v-flex d-flex xs12>
          <v-flex xs3></v-flex>
          <v-flex xs6>
            <v-card style="margin-top:20px">
              <v-card-text>
                <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Run Sheet</h3>
                </v-layout>
                <v-divider divider: true style="margin-bottom: 50px"></v-divider>
                <v-flex style="margin-left:20px">
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Challan No</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:10px">
                      <v-overflow-btn
                        :items="challanno"
                        label="Please Mention"
                        target="#dropdown-example"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Service Location / Hub</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:10px">
                      <v-overflow-btn
                        :items="servicelocation"
                        label="Please Mention"
                        target="#dropdown-example"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>City</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:10px">
                      <v-overflow-btn
                        :items="city"
                        label="Please Mention"
                        target="#dropdown-example"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Arrival Date</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        :return-value.sync="date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        style="margin-left:20px"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="date"
                        label="Select Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                      </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:30px">
                      <label>Arrival Time</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:20px">
                      <v-text-field
                        v-model="arrivaltime"
                        label=""
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Vehicle No</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:10px">
                      <v-overflow-btn
                        :items="vehicleno"
                        label="Please Mention"
                        target="#dropdown-example"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-btn class="primary" style="margin-left:20px;" v-on:click="submit()">Submit</v-btn>
                <v-btn class="default" style="margin-left:20px;">Reset</v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs3></v-flex>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      challanno: [],
      servicelocation: [],
      city: [],
      menu: false,
      date: new Date().toISOString().substr(0, 10),
      vehicleno: [],
      docketno: [],
      condition: ['Fine', 'Damaged', 'Incomplete', 'Lost'],
      arrivaltime: ''
    }
  },
  methods: {
    submit () {
      this.$router.push('/Transportationtripreport')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Transportationtrip.vue